import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import { Sidebar } from "_molecules";
import { useIsMobile } from "_utils/hooks";

const NewScreen = (props) => {
  // phones: the sidebar is a top bar with a hamburger, so stack it above the page
  const isMobile = useIsMobile();
  return (
    <div fluid={true} style={{ display: "flex", flexDirection: isMobile ? "column" : "row" }}>
      {props.sidebar == false ? (
        ""
      ) : (
        <div>
          <Sidebar />
        </div>
      )}
      <Container fluid={props.fluid} className="mt-3" style={props?.style}>
        {props.children}
      </Container>
    </div>
  );
};

export default NewScreen;
